@if (isReport && reportData?.data !== null) {
<div class="mc">

  <div class="mc__body">

    <!-- Photo column -->
    <div class="mc__photo-col" *ngxPermissionsOnly="'USER_ID_IMAGE_READ'">
      <div class="mc__photo-wrap">
        <img class="mc__photo"
             [src]="'data:image/jpg;base64,' + clientReportData?.Picture"
             alt="clientImage" />
      </div>
    </div>

    <div class="mc__data">

      <!-- Section: Document status -->
      <div class="mc__section">
        <div>
          <span class="s26-label" style="margin-right: 40px">{{ 'identityReports.idCardVerified' | translate }}</span>
          <span class="mc__doc-status"
                [class.mc__doc-status--valid]="clientReportData?.DocumentActualStatus === IDCardVerifiedType.VALID"
                [class.mc__doc-status--invalid]="clientReportData?.DocumentActualStatus !== IDCardVerifiedType.VALID">
            {{ clientReportData?.DocumentActualStatus }}
            @if (clientReportData?.DocumentStatusReason) {
              <span class="mc__doc-reason">— {{ clientReportData?.DocumentStatusReason }}</span>
            }
          </span>
        </div>
      </div>

      <!-- Section: Names -->
      <div class="mc__grid">
        <div class="mc__cell">
          <div class="s26-vfield">
            <span class="s26-label">{{ 'identityReports.lastName' | translate }}</span>
            <span class="s26-vfield__value" [matTooltip]="clientReportData?.PersonNames?.FamilyName">
              {{ clientReportData?.PersonNames?.FamilyName || '—' }}
            </span>
          </div>
        </div>
        <div class="mc__cell">
          <div class="s26-vfield">
            <span class="s26-label">{{ 'identityReports.firstName' | translate }}</span>
            <span class="s26-vfield__value" [matTooltip]="clientReportData?.PersonNames?.FirstName">
              {{ clientReportData?.PersonNames?.FirstName || '—' }}
            </span>
          </div>
        </div>
        <div class="mc__cell">
          <div class="s26-vfield">
            <span class="s26-label">{{ 'identityReports.middleName' | translate }}</span>
            <span class="s26-vfield__value" [matTooltip]="clientReportData?.PersonNames?.Surname">
              {{ clientReportData?.PersonNames?.Surname || '—' }}
            </span>
          </div>
        </div>
      </div>

      <!-- Section: Civil -->
      <div class="mc__grid">
        <div class="mc__cell">
          <div class="s26-vfield">
            <span class="s26-label">{{ 'global.civilId' | translate }}</span>
            <span class="s26-vfield__value s26-vfield__value--mono">{{ civilId || '—' }}</span>
          </div>
        </div>
        <div class="mc__cell">
          <div class="s26-vfield">
            <span class="s26-label">{{ 'global.genderAndAge' | translate }}</span>
            <span class="s26-vfield__value">
              {{ 'global.' + civilIdGender + 'Short' | translate }}
              / {{ civilIdAge }} {{ 'global.ageShort' | translate }}
            </span>
          </div>
        </div>
        <div class="mc__cell">
          <div class="s26-vfield">
            <span class="s26-label">{{ 'global.citizenship' | translate }}</span>
            <span class="s26-vfield__value"
                  [class.s26-vfield__value--warn]="clientReportData?.NationalityList?.length > 1"
                  [matTooltip]="clientReportData?.NationalityList | displayNationalityList">
              {{ clientReportData?.NationalityList | displayNationalityList }}
            </span>
          </div>
        </div>
      </div>

      <!-- Section: Birth + Physical -->
      <div class="mc__grid">
        <div class="mc__cell">
          <div class="s26-vfield">
            <span class="s26-label">{{ 'global.dateOfBirth' | translate }}</span>
            <span class="s26-vfield__value s26-vfield__value--mono">
              {{ (clientReportData?.BirthDate | date) || (clientReportData?.DataForeignCitizen?.BirthDate | date) || '—' }}
            </span>
          </div>
        </div>
        <div class="mc__cell">
          <div class="s26-vfield">
            <span class="s26-label">{{ 'mi.BirthPlace' | translate }}</span>
            <span class="s26-vfield__value" [matTooltip]="clientReportData?.BirthPlace?.TerritorialUnitName">
              {{ clientReportData?.BirthPlace?.TerritorialUnitName || clientReportData?.BirthPlace?.CountryName || '—' }}
            </span>
          </div>
        </div>
        <div class="mc__cell">
          <div class="s26-vfield">
            <span class="s26-label">{{ 'identityReports.height' | translate }}</span>
            <span class="s26-vfield__value">
              {{ clientReportData?.Height ? clientReportData.Height + ('global.cmShort' | translate) : '—' }}
            </span>
          </div>
        </div>
      </div>

      <!-- Section: Document details -->
      <div class="mc__grid">
        <div class="mc__cell">
          <div class="s26-vfield">
            <span class="s26-label">{{ 'identityReports.idCardNumber' | translate }}</span>
            <span class="s26-vfield__value s26-vfield__value--mono">{{ clientReportData?.IdentityDocumentNumber || '—' }}</span>
          </div>
        </div>
        <div class="mc__cell">
          <div class="s26-vfield">
            <span class="s26-label">{{ 'identityReports.idCardIssuedDate' | translate }}</span>
            <span class="s26-vfield__value s26-vfield__value--mono">{{ (clientReportData?.IssueDate | date) || '—' }}</span>
          </div>
        </div>
        <div class="mc__cell">
          <div class="s26-vfield">
            <span class="s26-label">{{ 'identityReports.idCardValidityDate' | translate }}</span>
            <span class="s26-vfield__value s26-vfield__value--mono">{{ (clientReportData?.ValidDate | date) || '—' }}</span>
          </div>
        </div>
      </div>

      <!-- Section: Issuer + Physical -->
      <div class="mc__grid">
        <div class="mc__cell">
          <div class="s26-vfield">
            <span class="s26-label">{{ 'identityReports.idCardIssuer.name' | translate }}</span>
            <span class="s26-vfield__value">{{ clientReportData?.IssuerName || '—' }}</span>
          </div>
        </div>
        <div class="mc__cell">
          <div class="s26-vfield">
            <span class="s26-label">{{ 'identityReports.height' | translate }}</span>
            <span class="s26-vfield__value">
              {{ clientReportData?.Height ? clientReportData.Height + ('global.cmShort' | translate) : '—' }}
            </span>
          </div>
        </div>
        <div class="mc__cell">
          <div class="s26-vfield">
            <span class="s26-label">{{ 'identityReports.eyes.eyeColor' | translate }}</span>
            <span class="s26-vfield__value">{{ clientReportData?.EyesColor || '—' }}</span>
          </div>
        </div>
      </div>

      <!-- Section: Address -->
      <div class="mc__grid">
        <div class="mc__cell">
          <div class="s26-vfield">
            <span class="s26-label">{{ 'identityReports.idCardAddress.city.name' | translate }}</span>
            <span class="s26-vfield__value" [matTooltip]="clientReportData?.PermanentAddress?.SettlementName">
              {{ clientReportData?.PermanentAddress?.SettlementName || '—' }}
            </span>
          </div>
        </div>
        <div class="mc__cell mc__cell--span2">
          <div class="s26-vfield">
            <span class="s26-label">{{ 'identityReports.idCardAddress.address' | translate }}</span>
            <span class="s26-vfield__value" [matTooltip]="clientReportData?.address">
              {{ clientReportData?.address || '—' }}
            </span>
          </div>
        </div>
      </div>

      <!-- Section: Foreign citizen (conditional) -->
      @if (dataForeignCitizen?.PN) {
        <div class="mc__grid">
          <div class="mc__cell">
            <div class="s26-vfield">
              <span class="s26-label">{{ 'mi.PIN' | translate }}</span>
              <span class="s26-vfield__value s26-vfield__value--mono" [matTooltip]="dataForeignCitizen?.PIN">
                {{ dataForeignCitizen?.PIN || '—' }}
              </span>
            </div>
          </div>
          <div class="mc__cell">
            <div class="s26-vfield">
              <span class="s26-label">{{ 'mi.PN' | translate }}</span>
              <span class="s26-vfield__value s26-vfield__value--mono" [matTooltip]="dataForeignCitizen?.PN">
                {{ dataForeignCitizen?.PN || '—' }}
              </span>
            </div>
          </div>
          <div class="mc__cell">
            <div class="s26-vfield">
              <span class="s26-label">{{ 'mi.RPTypeofPermit' | translate }}</span>
              <span class="s26-vfield__value" [matTooltip]="clientReportData?.RPTypeofPermit">
                {{ clientReportData?.RPTypeofPermit || '—' }}
              </span>
            </div>
          </div>
        </div>
      }

    </div>
  </div>

</div>
}